import {configureStore} from '@reduxjs/toolkit'
import {useDispatch, useSelector} from 'react-redux'
import {persistStore, persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import countryCodeReducer from './slices/countryCodeSlice'
import itemReducer from './slices/itemSlice'
import {commonSliceReducer} from '@/store/slices/commonSlice'
import themeReducer from './slices/themeSlice'
import {salesTargetSliceReducer} from '@/store/slices/salesTargetSlice'
import {userDetailsSliceReducer} from '@/store/slices/userSlice'

// Persist configuration for sales target reducer
const salesTargetPersistConfig = {
  key: 'salesTarget',
  storage,
  whitelist: ['salesTarget'], // only salesTarget will be persisted
}

// Create persisted sales target reducer
const persistedSalesTargetReducer = persistReducer(salesTargetPersistConfig, salesTargetSliceReducer)

export const reducers = {
  common: commonSliceReducer,
  theme: themeReducer,
  countryCode: countryCodeReducer,
  item: itemReducer,
  salesTarget: persistedSalesTargetReducer,
  userDetails: userDetailsSliceReducer,
}

export const store = configureStore({
  reducer: reducers,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'], // Ignore persist actions
      },
    }),
})

export const useAppDispatch = () => useDispatch()
export const useAppSelector = useSelector
export const persistor = persistStore(store)
